export default __webpack_public_path__ + "static/media/cyclist-icon.a0dfe718.png";